
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import {
  UserBaseInfoInterface,
  UserRepoInterface,
} from '@/services/Users/Interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import AddAgentForm from '@/services/Dossier/user/forms/AddAgentForm';
import DossierUserRepositoryInterface, { AgentInterface } from '@/services/Dossier/user/interfaces';
import DossierPositionRepositoryInterface, { AgentPositionInterface } from '@/services/Dossier/position/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'dossierUserRepository',
    'dossierPositionRepository',
    'userRepository',
    'profileRepository',
  ],
})
export default class UpdateAgent extends Vue {
  private form: WPXFormValue<AddAgentForm> = new WPXFormValue(AddAgentForm);

  private loading: boolean = true;

  private dossierUserRepository!: DossierUserRepositoryInterface;
  private dossierPositionRepository!: DossierPositionRepositoryInterface;
  private userRepository!: UserRepoInterface;

  private userId!: string;
  private agent!: AgentInterface;

  private positions: AgentPositionInterface[] = [];
  private users: UserBaseInfoInterface[] = [];

  private async created(): Promise<void> {
    if (!this.$route.params.userId) {
      this.$errorDialog.show('User id not provided');
      return;
    }
    this.userId = this.$route.params.userId;
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    try {
      this.positions = await this.dossierPositionRepository.getAllPositions();
      this.agent = await this.dossierUserRepository.getUser(this.userId);
      this.users = await this.userRepository.getUsersByIds([this.userId]);
      this.form.data.users = [this.userId];
      this.form.data.positionId = this.agent.position.id;
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

  private async updateAgent(): Promise<void> {
    try {
      if (this.agent.position.id !== this.form.data.positionId) {
        await this.dossierUserRepository.updateUser(this.userId, this.form.data.positionId);
      }

      this.$successDialog.show('Agent updated successfully');
      await this.goBack();
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

  private async goBack(): Promise<void> {
    await this.$router.push({ name: 'all-agents' });
  }
}
